import React from 'react';
import Pointer from "../../../Components/Pointer";

const FaveLearnButtonSet = ({customStyles, getPrevLearnSlide, getNextLearnSlide}) => {
    return (
        <div className={customStyles}>
            <Pointer direction={"left"} task={getPrevLearnSlide}
                     bgColor={"purple-slumber"}/>
            <Pointer direction={"right"} task={getNextLearnSlide}
                     bgColor={"purple-slumber"}/>
        </div>
    );
};

export default FaveLearnButtonSet;